const ASSET_RECOVERY_KEY_PREFIX = 'rooted:portal-asset-recovery'
const APPLICATION_ASSET_SELECTOR = [
  'script[src*="/vite/assets/application-"]',
  'link[rel="stylesheet"][href*="/vite/assets/application-"]',
].join(', ')

const recoveryKey = channel => `${ASSET_RECOVERY_KEY_PREFIX}:${channel}`

export const assetEntrySignature = document => Array.from(document.querySelectorAll(APPLICATION_ASSET_SELECTOR))
  .map(element => element.getAttribute('src') || element.getAttribute('href'))
  .filter(Boolean)
  .sort()
  .join('|')

export const availableSessionStorage = browserWindow => {
  try {
    return browserWindow.sessionStorage
  } catch {
    return null
  }
}

export const clearAssetRecoveryAttempt = (storage, channel) => {
  try {
    storage.removeItem(recoveryKey(channel))
    return true
  } catch {
    return false
  }
}

export const claimAssetRecoveryAttempt = (targetSignature, storage, channel) => {
  if (!targetSignature || !storage) return 'manual'

  try {
    const key = recoveryKey(channel)
    if (storage.getItem(key) === targetSignature) return 'manual'

    storage.setItem(key, targetSignature)
    return 'reload'
  } catch {
    return 'manual'
  }
}

export const planAssetRecovery = ({ currentSignature, nextSignature, storage }) => {
  if (!currentSignature || !nextSignature) return 'unavailable'

  if (currentSignature === nextSignature) {
    clearAssetRecoveryAttempt(storage, 'freshness')
    return 'stable'
  }

  return claimAssetRecoveryAttempt(nextSignature, storage, 'freshness')
}

export const requestManualAssetReload = (storage, reload) => {
  try {
    clearAssetRecoveryAttempt(storage, 'freshness')
    clearAssetRecoveryAttempt(storage, 'preload')
  } finally {
    reload()
  }
}
